module.exports = __webpack_public_path__ + "media/images/sales/early/btn-cta-4-9a3163656bac9c2aceb72bbcb5b5cf84.svg";